<template>
  <div class="table-responsive text-nowrap">
    <a-table :columns="columns" :row-key="data.id" :data-source="data" :pagination="false" :loading="loading">
      <template #general="{ text }">
        <a-row>
          <a-col :lg="{ span: 8 }" :md="{ span: 24 }" class="text-right font-weight-bold pr-2">
            Nombre:
          </a-col>
          <a-col :lg="{ span: 16 }" :md="{ span: 24 }" class="text-left pl-2">
            {{ text.name }}
          </a-col>
        </a-row>
        <a-row>
          <a-col :lg="{ span: 8 }" :md="{ span: 24 }" class="text-right font-weight-bold pr-2">
            Correo electrónico:
          </a-col>
          <a-col :lg="{ span: 16 }" :md="{ span: 24 }" class="text-left pl-2">
            {{ text.email }}
          </a-col>
        </a-row>
      </template>
      <template #detail="{ text }">
        <a-row>
          <a-col span="12" class="text-right font-weight-bold pr-2">
            Rol:
          </a-col>
          <a-col :lg="{ span: 12 }" :xs="{ span: 24 }" class="text-left pl-2">
            <span v-if="text.role === 'DRIVER'">
              Conductor
            </span>
            <span v-else-if="text.role === 'OPERATIVE_ADMIN'">
              Administrador Operativo
            </span>
            <span v-else>
              Super Administrador
            </span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :lg="{ span: 12 }" :xs="{ span: 24 }" class="text-right font-weight-bold pr-2">
            Unidad de negocio:
          </a-col>
          <a-col :lg="{ span: 12 }" :xs="{ span: 24 }" class="text-left pl-2">
            <span class="text-danger" v-if="!text.businessUnit">
              No Asignado
            </span>
            <span v-else>
              {{ text.businessUnit.code }} - {{ text.businessUnit.name }}
            </span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :lg="{ span: 12 }" :xs="{ span: 24 }" class="text-right font-weight-bold pr-2">
            Económico:
          </a-col>
          <a-col :lg="{ span: 12 }" :xs="{ span: 24 }" class="text-left pl-2">
            <span class="text-danger" v-if="!text.truckCode">
              No Asignado
            </span>
            <span v-else>
              {{ text.truckCode }}
            </span>
          </a-col>
        </a-row>
      </template>
      <template #action="{ text }">
        <a-button @click="$emit('openModal', text)" class="btn btn-sm btn-light mr-2">
          <i class="fe fe-edit mr-2" />
          Editar
        </a-button>
        <a-button @click="$emit('softDelete', text)" class="btn btn-sm btn-outline-danger mr-2">
          <i class="fe fe-trash mr-2" />
          Eliminar
        </a-button>
      </template>
    </a-table>
  </div>
</template>

<script>

const columns = [
  {
    title: 'General',
    dataIndex: '',
    slots: { customRender: 'general' },
    class: 'text-center',
  },
  {
    title: 'Detalles',
    dataIndex: '',
    slots: { customRender: 'detail' },
    class: 'text-center',
  },
  {
    title: 'Acciones',
    slots: { customRender: 'action' },
    class: 'text-center',
  },
]

export default {
  name: 'UserTable',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Object],
      require: true,
      defaultValue: {},
    },
    // eslint-disable-next-line vue/require-default-prop
    loading: {
      type: [Boolean],
      require: true,
      defaultValue: false,
    },
  },
  emits: [
    'openModal', 'softDelete',
  ],
  setup() {
    return {
      columns,
    }
  },
}
</script>

<style scoped></style>
